import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatPaginator, MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource, MatSnackBar, PageEvent, MatDialog } from '@angular/material';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { CreatePruebaComponent } from './create-prueba/create-prueba.component';
import { Router } from '@angular/router';
import { Handle } from '../../handle';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Md5 } from 'ts-md5/dist/md5';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ClienteinfoService } from 'src/app/services/clienteinfo.service';
import { takeUntil, max } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { Subject, Subscription } from 'rxjs';
import { BusquedaService } from '../busqueda.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-config-blacklist',
  templateUrl: './config-blacklist.component.html',
  styleUrls: ['./config-blacklist.component.scss']
})
export class ConfigBlacklistComponent implements OnInit {
  private destroy$ = new Subject<void>();

  @ViewChild('paginatordistribuidor') paginatordistribuidor: MatPaginator;

  WhatsAppForm = new FormGroup({
    ESTADOTIPOMSJ: new FormControl(null, [Validators.compose([
      Validators.required
    ])]),
    ESTADOMSJINI: new FormControl(null, [Validators.compose([
      Validators.required
    ])]),
    MENSAJE1: new FormControl(null, [Validators.compose([
      Validators.required
    ])]),
    MENSAJE2: new FormControl(null, [Validators.compose([
      Validators.required
    ])]),
    VARIABLE1: new FormControl(null, [Validators.compose([
      Validators.required
    ])]),
    VARIABLE2: new FormControl(null, [Validators.compose([
      Validators.required
    ])]),
    BOTON1INI: new FormControl(null, [Validators.compose([
      Validators.required
    ])]),
    BOTON2INI: new FormControl(null, [Validators.compose([
      Validators.required
    ])]),
    BOTON3INI: new FormControl(null, [Validators.compose([
      Validators.required
    ])]),
    IMAGENINI: new FormControl(null, [Validators.compose([
      Validators.required
    ])]),
    PROBATEL1: new FormControl(null, [Validators.compose([
      Validators.required
    ])]),
    CANTIDAD: new FormControl(100, [Validators.compose([
      Validators.required, Validators.min(100), Validators.max(10000), Validators.pattern(/^[+-]?\d+$/)
    ])]),
    ESTADO: new FormControl(true, [Validators.compose([
      Validators.required
    ])]),
  });

  msjprueba1 = '';
  msjprueba2 = '';
  msjprueba3 = '';
  txtomsj1 = '';
  variablemsj1 = '';
  txtomsj2 = '';
  variablemsj2 = '';
  txtomsj3 = '';
  variablemsj3 = '';
  imagen1 = '';
  imagen2 = '';
  imagen3 = '';
  cantmax = '';
  estado = true;
  loading = false;

  campanaColumns: string[] = ['IDENVIO', 'NOMBRE', 'CANTIDADNUM', 'ESTADO', 'ACCION'];
  private subscription: Subscription;
  dataSource = new MatTableDataSource<any>([]);
  cantidad = -1;
  FILTER; resultsLength = 0;
  pageSize = 5;
  idpais;
  pageEvent: PageEvent;
  public actpage: number = 0;

  constructor(
    public Handle: Handle,
    private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar,
    private localSave: LocalSaveService,
    private clienteinfo: ClienteinfoService,
    private router: Router,
    public pageTitle: ComponentPageTitle,
    private dialog: MatDialog,
    public _busqueda: BusquedaService,
    private gateway: GatewayService) { }

  ngOnInit() {
    const user = this.localSave.get('usuarioPGV');
    if (!user || user.idrol != 10) {
      this.router.navigate(['/home']);
    }
    this.pageTitle.title = 'Configuración BlackList';
    this.spinner.show();

    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.filtrardistribuidor(res.filtro);
      });

    this.gateway.get('getConfigBlackList', {}).then((result: any) => {
      let data = result.rows[0];

      this.WhatsAppForm.controls.MENSAJE1.setValue(data.mensaje1),
        this.WhatsAppForm.controls.MENSAJE2.setValue(data.mensaje2),
        this.WhatsAppForm.controls.VARIABLE1.setValue(data.variable1),
        this.WhatsAppForm.controls.VARIABLE2.setValue(data.variable2),
        this.WhatsAppForm.controls.BOTON1INI.setValue(data.boton1ini),
        this.WhatsAppForm.controls.BOTON2INI.setValue(data.boton2ini),
        this.WhatsAppForm.controls.BOTON3INI.setValue(data.boton3ini),
        this.WhatsAppForm.controls.IMAGENINI.setValue(data.imagenini),
        this.WhatsAppForm.controls.PROBATEL1.setValue(data.probatel1),
        this.WhatsAppForm.controls.CANTIDAD.setValue(data.cantidad),
        this.WhatsAppForm.controls.ESTADO.setValue(data.estado)
      this.spinner.hide();
    }
    ).catch(function (e) {
    });

    this.gateway.get('getAllEnviosMasivos', {})
      .then((result: any) => {
        this.cantidad = result.rows[0].total;
      });

    this.get(0);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription.unsubscribe();
  }

  // ============== FILTRO ==============
  filter = '';
  public keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.filtrogeneral();
    } else if (event.keyCode == 8 && this.filter == '') {
      this.filtrogeneral();
    }
  }
  public filtrogeneral() {
    this._busqueda.notificarBusqueda({ filtro: this.filter });
  }

  filtrardistribuidor(data) {
    this.FILTER = data;
    this.get(0)
  }

  get(page) {
    this.spinner.show();
    if (page == 0) {
      this.paginatordistribuidor.firstPage();
    }
    this.gateway.get('getEnviosMasivos', { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize }).then((result) => {
      //console.log(result);
      let aux: any = result;
      this.dataSource = aux.rows;

      this.gateway.get('getEnviosMasivosCount', { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize }).then((result: any) => {
        //console.log(result.rows);
        this.resultsLength = result.rows[0].total;
        this.spinner.hide();
      });
    }
    ).catch(function (e) {
    });
  }

  actualizaMensaje() {
    this.loading = true;
    this.spinner.show();

    let form = {
      // ESTADOTIPOMSJ: this.WhatsAppForm.controls.ESTADOTIPOMSJ.value,
      // ESTADOMSJINI: this.WhatsAppForm.controls.ESTADOMSJINI.value,
      MENSAJE1: this.WhatsAppForm.controls.MENSAJE1.value,
      MENSAJE2: this.WhatsAppForm.controls.MENSAJE2.value,
      VARIABLE1: this.WhatsAppForm.controls.VARIABLE1.value,
      VARIABLE2: this.WhatsAppForm.controls.VARIABLE2.value,
      BOTON1INI: this.WhatsAppForm.controls.BOTON1INI.value,
      BOTON2INI: this.WhatsAppForm.controls.BOTON2INI.value,
      BOTON3INI: this.WhatsAppForm.controls.BOTON3INI.value,
      IMAGENINI: this.WhatsAppForm.controls.IMAGENINI.value,
      PROBATEL1: this.WhatsAppForm.controls.PROBATEL1.value,
      CANTIDAD: this.WhatsAppForm.controls.CANTIDAD.value,
      ESTADO: this.WhatsAppForm.controls.ESTADO.value
    }

    this.gateway.get('saveConfigBlackList', form).then((result: any) => {
      this.loading = false;
      this.spinner.hide();
    }
    ).catch(function (e) {
    });
  }

  sendSMS() {
    // this.spinner.show();
    let telefono = this.WhatsAppForm.controls.PROBATEL1.value;
    if (!isNaN(telefono.toString())) {
      this.gateway.get('sendSMSorWA', {
        MENSAJE2: this.WhatsAppForm.controls.MENSAJE2.value,
        PROBATEL1: this.WhatsAppForm.controls.PROBATEL1.value
      }).then((result: any) => {
        this.snackbar.open(`Mensaje enviado con éxito.`, 'Cerrar', { duration: 3000 });
        // this.spinner.hide();
      }
      ).catch(function (e) {
        // this.spinner.hide();
      });
    } else {
      this.snackbar.open(`Debe de ingresar un número de telefono válido.`, 'Cerrar', { duration: 3000 });
      // this.spinner.hide();
    }
  }

  public onFileChange(evt: any, id) {
    // if (id == 1) {
    //   this.imagen1 = evt.target.value.split('\\')[evt.target.value.split('\\').length - 1];
    // } else if (id == 2) {
    //   this.imagen2 = evt.target.value.split('\\')[evt.target.value.split('\\').length - 1];
    // } else if (id == 3) {
    //   this.imagen3 = evt.target.value.split('\\')[evt.target.value.split('\\').length - 1];
    // }
  }

  createPrueba() {
    this.actualizaMensaje();
    if (this.cantidad > -1) {
      const dialogRef = this.dialog.open(CreatePruebaComponent, {
        // maxWidth: '90vw',
        width: '420px',
        // minHeight: '40vh',
        data: { operacion: 'Crear', cantidad: this.cantidad },
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        this.get(this.actpage);
      });
    }
  }

  enviar(element) {
    this.spinner.show();
    this.gateway.get('sendEnvioMasivo', {
      IDENVIO: element.idenvio,
      NOMBRE: element.nombre,
      CANTIDAD: element.cantidad,
      ESTADO: element.estado,
      FECHACREACION: element.fechacreacion
    }).then((result: any) => {
      //console.log(result.rows);
      this.get(this.actpage);
      this.spinner.hide();
      this.snackbar.open(`Envio masivo ejecutado con éxito.`, 'Cerrar', { duration: 3000 });
    });
  }

  descargar(element) {
    this.spinner.show();
    this.gateway.get('descargarClientes', {
      IDENVIO: element.idenvio,
      NOMBRE: element.nombre,
      CANTIDAD: element.cantidad,
      ESTADO: element.estado,
      FECHACREACION: element.fechacreacion
    }).then((result: any) => {
      //console.log(result.rows);
      let datos = result.rows;
      if (datos.length > 0) {
        this.descargarexcel(datos, element)
      } else {
        this.snackbar.open('No hay números de telefono.', 'Cerrar', { duration: 3000, });
        this.spinner.hide();
      }

    });
  }

  descargarexcel(ctr, element) {
    const fileName = 'EnvioMasivo_' + element.nombre + '-' + Date.now();
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(ctr);
    XLSX.utils.book_append_sheet(wb, ws);

    const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
    this.spinner.hide();
  }

}
